<template>
  <div class="container">
    <h1>Request Access Queue</h1>
    <div class="columns">
      <div class="column is-3">
        <b-input v-model="filter" placeholder="Filter Queue"></b-input>
      </div>
    </div>
    <b-table :data="filteredRequests"
             :hoverable="true"
             :loading="isLoading"
             :mobile-cards="true"
             :paginated="true"
             pagination-position="both"
             :per-page="10"
             :pagination-simple="true">
      <b-table-column field="Email" label="Email" sortable v-slot="props">
        <a v-if="props.row.UserManagerId != null" @click="externalModal(props.row)">{{ props.row.Email }}</a>
        <a v-else @click="grantAccessModal(props.row)">{{ props.row.Email }}</a>
      </b-table-column>
      <b-table-column field="Type" label="Type" sortable v-slot="props">
        {{ props.row.Type }}
      </b-table-column>
      <b-table-column field="Organization" label="Organization" sortable v-slot="props">
        {{ props.row.Organization }}
      </b-table-column>
      <b-table-column field="Status" label="Status" sortable v-slot="props">
        {{ props.row.Status }}
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
  import GrantAccess from "@/components/modals/grantAccess.vue";
  import AdminExternalRequest from '@/components/modals/adminExternalRequest.vue';
  export default {
    data() {
      return {
        requests: [],
        isLoading: false,
        filter: ""
      }
    },
    created() {
      this.getRequests();
    },
    computed: {
      filteredRequests() {
        return this.requests.filter((option) => {
          if (option.Email.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return true;
          }
          if (option.Organization.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return true;
          }
          if (option.Status.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0) {
            return true;
          }
        });
      }
    },
    methods: {
      async getRequests() {
        this.isLoading = true;
        await this.$http.get("api/request")
          .then(resp => {
            this.requests = resp.data;
            this.isLoading = false;
          }).catch(err => {
            console.error(err);
            this.isLoading = false;
          })
      },
      grantAccessModal(model) {
        this.$buefy.modal.open({
          parent: this,
          component: GrantAccess,
          hasModalCard: true,
          width: 960,
          props: {
            Request: model
          },
          events: {
            'refresh': async (user) => {
              await this.getRequests();
            }
          }
        })
      },
      externalModal(model) {
        this.$buefy.modal.open({
          parent: this,
          component: AdminExternalRequest,
          hasModalCard: true,
          width: 960,
          props: {
            Request: model
          },
          events: {
            'refresh': async (user) => {
              await this.getRequests();
            }
          }
        })
      }
    }
  }
</script>
